<template>
  <div class="main-container">
    <HeaderNav></HeaderNav>
    <div style="width: 100%">
      <RouterView></RouterView>
    </div>
    <FooterNav></FooterNav>
    <FixedRight></FixedRight>
  </div>
</template>
<script setup>
import { RouterView } from 'vue-router'

import HeaderNav from '@/components/layout/headerNav/headerNav.vue'
import FooterNav from '@/components/layout/footerNav/footerNav.vue'
import FixedRight from '@/components/layout/fixedRight/fixedRight.vue'
import { computed } from 'vue'
import { useStore } from 'vuex'
const store = useStore();
const userInfo = computed(()=>store.state.user.userInfo) //ref(true)//;
</script>

<style lang="scss" scoped>
.main-container {
  width: 100%;
  min-width: 1200px;
  background: #f5f7f9;
}
</style>
